import { render } from "./CoursesEditor.vue?vue&type=template&id=6ea9dc4e&scoped=true"
import script from "./CoursesEditor.vue?vue&type=script&lang=js"
export * from "./CoursesEditor.vue?vue&type=script&lang=js"

import "./CoursesEditor.vue?vue&type=style&index=0&id=6ea9dc4e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ea9dc4e"]])

export default __exports__